//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'CourseList',
  data() {
    return {
      courseMenuActive: 0,
      courseList: [],
      conditions: {},
    };
  },
  computed: {
    ...mapGetters('user', ['token']),
    ...mapGetters('lecturer', ['teachingFieldsMenu']),
  },
  methods: {
    getLecturerCourse(payload) {
      this.$api('getLecturerCourse', payload).then(data => {
        this.courseList = data.records;
      });
    },
    onCourseMenuClick(index, value) {
      this.conditions = { type: value };
      this.courseMenuActive = index;

      let payload = {};
      if (value) payload.teachingFieldIds = [value];

      this.getLecturerCourse(payload);
    },
  },
  watch: {
    token() {
      // 登入後 重撈課程資訊
      if (this.token) this.getLecturerCourse();
    },
  },
  mounted() {
    this.getLecturerCourse();
  },
};
